import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import LogoImage from "../../images/LandingPageImage/Isancharr.svg";
import { CircleArrowRight, Menu, X } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="w-full font-inter bg-brand-light m-0 px-4 py-4 md:py-8 sm:px-8 md:px-20 lg:px-24 xl:px-40 relative">
      <div className="flex items-center justify-between gap-4">
        <Link to="/" className="p-0 m-0" aria-label="Isancharr Home">
          <img
            src={LogoImage}
            className="w-32 sm:w-37.5 h-auto block"
            alt="Isancharr logo"
          />
        </Link>

        <button
          className="sm:hidden p-2 text-brand-dark transition-all"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        <div
          className={`
            ${isOpen ? "flex" : "hidden"} 
            sm:flex flex-col sm:flex-row items-center gap-2.5 sm:gap-3 
            absolute sm:static top-full left-0 w-full sm:w-auto 
            bg-brand-light sm:bg-transparent p-4 sm:p-0 
            shadow-lg sm:shadow-none z-50
          `}
        >
          {/* <button
            onClick={() => navigate("/signup")}
            className="bg-brand-primary w-full sm:w-auto py-2 px-4 text-white rounded-[10px] border-none flex gap-2 items-center justify-center transition-all hover:opacity-90"
          >
            <span>Sign Up</span>
            <CircleArrowRight size={20} />
          </button> */}

          <button
            onClick={() => navigate("/login")}
            className="bg-brand-dark w-full sm:w-auto py-2 px-12 text-white rounded-[10px] border-none transition-all hover:opacity-90"
          >
            Login
          </button>
        </div>
      </div>
    </nav>
  );
}